import validate from "/vercel/path1/node_modules/.pnpm/nuxt@4.3.1_@parcel+watcher@2.5.4_@types+node@24.11.0_@upstash+redis@1.36.3_@vue+compile_229b3328d74af7dcc5b1bd48bcad6eac/node_modules/nuxt/dist/pages/runtime/validate.js";
import trailing_45slash_45global from "/vercel/path1/app/middleware/trailing-slash.global.ts";
import manifest_45route_45rule from "/vercel/path1/node_modules/.pnpm/nuxt@4.3.1_@parcel+watcher@2.5.4_@types+node@24.11.0_@upstash+redis@1.36.3_@vue+compile_229b3328d74af7dcc5b1bd48bcad6eac/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  trailing_45slash_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}